import React, { useEffect } from 'react';
import { usePrevious } from 'js/hooks/usePrevious';
import { LocalPopup } from 'js/components/common/Popup';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { useNavigateToPopupBackgroundPage } from 'js/components/system/Router/components/PageRouter/hooks';
import { getCleanUrl } from 'js/utils/url.util';
import * as hooks from 'js/components/system/Page/components/PageInPopup/hooks';
import * as hocs from 'js/components/system/Page/hocs';
import { PagePopup } from 'js/components/system/Page/components/PagePopup';
import { useSmartClosePopups } from 'js/components/common/PopupManager';
import style from 'js/components/system/Page/components/PagePopup/PagePopup.scss';

export const PageInPopupBare = ({ page, error, isLoading, fetchPageInfo }) => {
    const cleanUrl = getCleanUrl();
    const navigateToPopupBackgroundPage = useNavigateToPopupBackgroundPage();
    const previousPage = usePrevious(page);
    const isRegisterPage = cleanUrl === '/register';
    const isForgotPasswordPage = cleanUrl === '/forgotten_password';
    const closePopups = useSmartClosePopups();
    hooks.useLegacyPageAsPopupCloseSubscription();
    hooks.useCMSIntegration({ page, fetchPageInfo });

    useEffect(() => {
        if (isRegisterPage || isForgotPasswordPage) {
            closePopups({
                popups: ['expandedCategoryPopup', 'iFeelLuckyPopup']
            });
        }
    }, [closePopups, isForgotPasswordPage, isRegisterPage]);

    if (!page) {
        return null;
    }

    if (isLoading) {
        return previousPage
            ? <PagePopup page={previousPage} />
            : null;
    }

    if (error) {
        return (
            <LocalPopup
                onClose={navigateToPopupBackgroundPage}
                style={{ width: '30em' }}
                className={style.container}
            >
                <ErrorMessage
                    className={style.error}
                    message={'playtech.mobile.system.error.no.response'}
                />
            </LocalPopup>
        );
    }

    return (
        <PagePopup page={page} isLoading={isLoading} />
    );
};

export const PageInPopup = hocs.withCommonPage(PageInPopupBare, true);
